import { render, staticRenderFns } from "./BecomeProvider.vue?vue&type=template&id=38fee5d5&scoped=true"
import script from "./BecomeProvider.vue?vue&type=script&lang=js"
export * from "./BecomeProvider.vue?vue&type=script&lang=js"
import style0 from "./BecomeProvider.vue?vue&type=style&index=0&id=38fee5d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fee5d5",
  null
  
)

export default component.exports